// Radix UI Theme Configuration
// You can customize the theme by passing these props to the Theme component

export const themeConfig = {
  // Accent colors: tomato, red, crimson, pink, plum, purple, violet, indigo, blue, cyan, teal, jade, green, grass, brown, orange, sky, mint, lime, yellow, amber
  accentColor: "blue",

  // Gray colors: gray, mauve, slate, sage, olive, sand, tomato, red, crimson, pink, plum, purple, violet, indigo, blue, cyan, teal, jade, green, grass, brown, orange, sky, mint, lime, yellow, amber
  grayColor: "gray",

  // Border radius: none, small, medium, large, full
  radius: "medium",

  // Scaling: 90%, 95%, 100%, 105%, 110%
  scaling: "100%",

  // Panel background: solid, transparent
  panelBackground: "solid",

  // Appearance: inherit, light, dark
  appearance: "inherit",
};

// Example of how to use this configuration:
// import { Theme } from '@radix-ui/themes';
// import { themeConfig } from './config/radixTheme';
//
// <Theme {...themeConfig}>
//   <YourApp />
// </Theme>

export default themeConfig;
